import {CheckmarkCircleIcon, CircleIcon} from '@sanity/icons'

export const TASK_STATUS = [
  {value: 'open', title: 'To Do', icon: <CircleIcon />},
  {value: 'closed', title: 'Done', icon: <CheckmarkCircleIcon />},
]
